import { useMemo, useState, Fragment } from "react";
import { useQuery } from "@apollo/client";
import { Button, Space, Typography } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { QuestionsQuery } from "../../types/survey";
import { GET_QUESTIONS } from "../Survey/survey.gql";
import { GET_ANSWERS } from "./answers.qql";

const { Paragraph } = Typography;

const Answers = (props: { patientId?: string }) => {
  const { t } = useTranslation();
  const { patientId } = props;
  const [expanded, setExpanded] = useState(false);

  const {
    data: questionsData
  } = useQuery<QuestionsQuery>(GET_QUESTIONS);

  const {
    data: answersData
  } = useQuery<{
    answers: {
      content: string;
    }
  }>(GET_ANSWERS, {
    variables: {
      patientId: Number(patientId)
    },
    skip: !questionsData
  });

  const answersArray = useMemo(() => {
    return answersData?.answers ? Object.entries(JSON.parse(answersData.answers.content)) : [];
  }, [answersData]);

  const booleanAnswer = (answer: boolean) => (answer ? "Yes" : "No");
  // @TODO: fix ignore
  // @ts-ignore
  const questionTitle = (key: string) => (questionsData ? questionsData.questions.find(item => item.id === key).content : "");

  const ellipseButton = (exp: boolean) => (
    <Button
      type="link"
      block
      size="small"
      style={{ padding: 0, margin: "0 0 0 -4px", textAlign: "left" }}
    >
      <Space size={2}>{exp ? t("global.button.readLess") : t("global.button.readMore")} <ArrowRightOutlined style={{ width: 14 }} /></Space>
    </Button>
  );

  return (
    answersData
      ? (
        <Paragraph
          type="secondary"
          ellipsis={{
            rows: 7,
            expandable: "collapsible",
            expanded,
            symbol: (ellipseButton),
            onExpand: (_, info) => setExpanded(info.expanded),
          }}
          style={{ marginBottom: 0 }}
        >
          {answersArray.map(([key, value]) => (
            <Fragment key={key}>
              <span style={{ marginBottom: 20 }}>
                {questionsData
                  ? <span>{questionTitle(key)}</span>
                  : null}
                {": "}
                <b>
                  {value === null ? "-" : null}
                  {typeof value === "string" ? value : null}
                  {typeof value === "boolean" ? booleanAnswer(value) : null}
                  {Array.isArray(value) ? value.toString() : null}
                </b>
              </span>
              <br/>
            </Fragment>
          ))}
        </Paragraph>
      )
      : null
  );
};

export default Answers;
